import React from "react";
import "./thesis.css";
import Comparison from "./image/comparison.png";
import Convergence from "./image/convergence.png";
import Brutnet from "./image/brutnet.png";
import { width } from "@fortawesome/free-brands-svg-icons/fa42Group";
import conceptual from "./image/conceptual.png";
import DICL from "./image/Main Final Algo.drawio.png";
import Fig from "./image/fig.png";

export default function MasterThesisBody() {
  return (
    <div className="bachelor-thesis-body">
      <h2 className="thesis-title">
        Title: Enhancing Deep Reinforcement Learning with Curriculum Learning for Robotic Tasks
      </h2>

      <div className="thesis-supervisors">
  <p>
    <b>Internal Supervisor:</b> Dr. Zoltán Istenes 
  </p>
  <p>
    <b>External Supervisor:</b> Dr. Dániel Horváth
  </p>
</div>


      <p className="thesis-abstract" style={{textAlign: 'justify'}}>
        <b>Abstract:</b> Reinforcement Learning (RL) algorithms often exhibit suboptimal performance in sparse-reward robotic environments due to insufficient exploration, low sample efficiency, and convergence instability. These challenges are particularly critical in robotic systems, where environment interactions are expensive and policy robustness is paramount. Curriculum Learning (CL) has emerged as a principled framework to mitigate these limitations by structuring the learning process. However, most existing CL approaches rely on manually designed curricula or rigid scheduling heuristics, which often fail to generalize across diverse tasks or adapt to learning dynamics.

In this research, I propose novel CL strategies to improve Deep Reinforcement Learning (DRL) in sparse-reward continuous control environments—domains characterized by significant exploration difficulties, high data acquisition costs, and unstable learning dynamics. The proposed Incremental Graded Curriculum (IGC) dynamically adjusts task difficulty based on agent performance, accelerating early learning. In parallel, the Dual Buffer Mechanism (DB) enhances replay efficiency by explicitly separating successful and failed episodes, enabling agents to learn from both experiences. These two components are unified in the Dual-Mechanism Incremental CL (DICL) framework, which integrates progressive task modulation with structured experience replay. 

Comprehensive empirical evaluations on three challenging robotic benchmarks—FetchPickAndPlace, FetchPush, and FetchSlide—show that the proposed methods consistently perform better than existing state-of-the-art approaches in terms of convergence speed, sample efficiency, and task success rate. These improvements are difficult to achieve in sparse-reward settings, which highlights the effectiveness and broad applicability of the proposed framework.
</p>
    <img src={DICL} alt="Conceptual Model" style={{ width: '100%', objectFit: 'cover' }} />
    <p className="result-caption">Fig 1: A schematic of the Dual-Mechanism Incremental Curriculum Learning
    (DICL) framework.</p>

      <div className="thesis-results">
        <h3 className="results-title">Results</h3>
       <p style={{fontSize:18, textAlign: 'justify'}}> <p style={{fontSize:18, textAlign: 'justify'}}> Our evaluation is structured around three main configurations to systematically
analyze the contributions of the proposed components:<br/>
• A baseline where the agent is trained using SAC combined solely with the
IGC, without any drop-penalty or DB mechanism.<br/>
• A baseline where SAC is augmented with drop-penalty reward shaping and the
DB mechanism, but without IGC. We also include HiER, a state-of-the-art
CL strategy, as a strong baseline under this configuration.<br/>
• Our full proposed DICL pipeline, integrating both IGC and DB, evaluated
against the SAC baseline with drop-penalty to isolate the benefit of CL.
<br/>
Each of these configurations is additionally evaluated with HER, PER, and their
combination to assess compatibility and cumulative performance gains. All experiments are run for 500K timesteps and repeated with 3 different random seeds.</p>
        <br/> </p>
        <div className="results-grid">
            <div className="result-item">
            <img src={Fig} alt="Comparison between State-of-the-art and ours" />
            <p className="result-caption">Fig 2: Comparison between our proposed methods and state-of-the-art
            baselines based on success rate with 95% confidence intervals on the Pushing, Sliding, and Pick-and-Place tasks of the Gymnasium-Robotics Fetch benchmark.</p>
            </div>
            <p className="result-caption"><b>Qualitative Evaluation</b></p>
              <p style={{textAlign: 'justify', fontSize: '18px'}}>Videos that demonstrate the effectiveness of our proposed methods can be found in the linked video. These demonstrations correspond to
one of the best-performing configurations, which achieves strong overall performance
across all tasks. The results highlight the advantages of our approach, including enhanced exploration, faster convergence, and greater reliability in task completion
under sparse-reward, continuous control environments.</p>
            <div className="video-container">
           
    <iframe
      width="100%"
      height="400"
      src="https://www.youtube.com/embed/dPOWdrsNT6Y"
      title="YouTube video"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
    ></iframe>
  </div>

        </div>
        </div>

      <div className="thesis-download">
        <a
          href="https://drive.google.com/file/d/1beaIxrRjhl7sySahbcR9uQu9tskX9zg2/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"

        >
          Download Thesis Book (PDF)
        </a>
      </div>

      <div className="thesis-researchgate">
        <a
          href="###"
          target="_blank"
          rel="noopener noreferrer"
        >
          View on ResearchGate
        </a>
      </div>

      <div className="thesis-pdf-preview">
      <iframe
  src="https://drive.google.com/file/d/1beaIxrRjhl7sySahbcR9uQu9tskX9zg2/preview" 
  width="100%"
  height="100%"
  title="Thesis Book Preview"
></iframe>

      </div>
      <div className="thesis-pdf-preview">
      <p className="result-caption"><b>Poster</b></p>
      <iframe
  src="https://drive.google.com/file/d/1oK2XpEEPIbKT4fyVLRPYQMGy-kXmghF8/preview" 
  width="100%"
  height="100%"
></iframe>
</div>

    </div>
  );
}
